export default "__VITE_ASSET__1fc01edf__"